import React from 'react';
import { Box, Typography } from '@mui/material';
import slide1 from '../../assets/11.png'; // Imagem principal
import secondaryImage from '../../assets/marcas.png'; // Imagem abaixo do texto
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Hero = () => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 'none',
        margin: '0',
        padding: '0',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#ffffff', // Fundo branco da Box pai
      }}
    >
      {/* Box Pai que envolve ambas as colunas */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          width: '100%',
          backgroundColor: '#ffffff', // Fundo branco para a Box pai
        }}
      >
        {/* Coluna da esquerda - Imagem única */}
        <Box
          sx={{
            flexBasis: { xs: '100%', md: '70%' }, // Define a largura das colunas
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            src={slide1}
            alt="Imagem promocional"
            style={{
              width: '100%',
              height: 'auto',
            }}
          />
        </Box>

        {/* Coluna da direita */}
        <Box
          sx={{
            flexBasis: { xs: '100%', md: '30%' }, // Define a largura das colunas
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center', // Centraliza verticalmente
            alignItems: 'center', // Centraliza horizontalmente
            backgroundColor: '#ffffff',
            padding: { xs: '10px', md: '20px' },
            marginTop: { lg: '10px', md: '5px' },
            textAlign: 'center', // Garante que o texto também seja centralizado
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "#103874",
              fontWeight: 'bold',
              fontSize: { xs: '0.9rem', md: '1rem' },
              padding: { xs: '5px 0', md: '10px 0' },
            }}
          >
            Argus! Protegendo suas conquistas dos imprevistos
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: '#454545',
              fontSize: { xs: '0.75rem', md: '0.8rem' },
              padding: { xs: '5px 10px', md: '10px 20px' },
            }}
          >
            Para nós seu seguro é mais que um produto. É uma experiência completa. Faça uma cotação online e descubra como nossa empresa pode te ajudar a encontrar a melhor proteção. Trabalhamos com as melhores seguradoras do país.
          </Typography>
          
          {/* Adicionando a imagem abaixo do texto */}
          <Box
            sx={{
              marginTop: { xs: '10px', md: '15px' },
            }}
          >
            <Box
  component="img"
  src={secondaryImage}
  alt="Imagem complementar"
  sx={{
    width: { xs: '200px', sm: '250px', md: '312px', lg: '433px' },
    height: 'auto',
  }}
/>

          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
